import { OdspError, OdspErrorType } from '@fluidframework/odsp-driver-definitions';
import { DriverErrorType } from '@fluidframework/driver-definitions';

export function isOdspOutOfStorageError(error: OdspError) {
  return error.errorType === OdspErrorType.outOfStorageError;
}

export function isOdspInvalidFileNameError(error: OdspError) {
  return error.errorType === OdspErrorType.invalidFileNameError;
}

export function isOdspSnapshotTooBigError(error: OdspError) {
  return error.errorType === OdspErrorType.snapshotTooBig;
}

export function isOdspFetchTimeoutError(error: OdspError) {
  return error.errorType === OdspErrorType.fetchTimeout;
}

export function isOdspFluidNotEnabledError(error: OdspError) {
  return error.errorType === OdspErrorType.fluidNotEnabled;
}

export function isFileOverwrittenInStorage(error: OdspError) {
  return error.errorType === DriverErrorType.fileOverwrittenInStorage;
}

/**
 * Match an error against known fluid ODSP driver error types
 * @param error potential ODSP driver error
 * @returns OdspErrorType in case of a match
 */
export function tryMatchOdspDriverErrorType(error: unknown): OdspErrorType | DriverErrorType | undefined {
  if (typeof error === 'object') {
    const typedError = error as OdspError;

    if (isOdspOutOfStorageError(typedError)) {
      return OdspErrorType.outOfStorageError;
    }

    if (isOdspInvalidFileNameError(typedError)) {
      return OdspErrorType.invalidFileNameError;
    }

    if (isOdspSnapshotTooBigError(typedError)) {
      return OdspErrorType.snapshotTooBig;
    }

    if (isOdspFetchTimeoutError(typedError)) {
      return OdspErrorType.fetchTimeout;
    }

    if (isOdspFluidNotEnabledError(typedError)) {
      return OdspErrorType.fluidNotEnabled;
    }

    if (isFileOverwrittenInStorage(typedError)) {
      return DriverErrorType.fileOverwrittenInStorage;
    }

    // ... try match any other known ODSP driver error types
  }

  return;
}

// cspell:ignore ODSP Odsp odsp doclib
